import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { fetchAnalyticsChartData } from "../../../config/service";
import ChartLoader from "./Loading";

const ConversionChart = ({
  utm,
  toDate,
  fromDate,
  isLoader,
  setIsLoader,
  activeTab,
}) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    handleFetchData();
  }, [utm, toDate, activeTab, fromDate]);

  const handleFetchData = async () => {
    try {
      setIsLoader(true);
      const response = await fetchAnalyticsChartData({
        type: "conversion",
        utm,
        fromDate,
        toDate,
      });
      setData(response.data);
    } catch (error) {
      console.error("Error fetching conversion data:", error);
    } finally {
      setIsLoader(false);
    }
  };

  if (isLoader || !data) return <ChartLoader isLoader={isLoader} />;
    if (!isLoader && (!data || data.totalSessions === 0))
      return (
        <div className="d-flex justify-content-center align-items-center py-5">
          <h4>No data available</h4>
        </div>
      );

    const options = {
      chart: { type: "radialBar" },
      labels: ["Conversion Rate"],
      plotOptions: {
        radialBar: {
          dataLabels: {
            name: {
              offsetY: -10,
              color: "var(--text-primary)",
              fontSize: "16px",
            },
            value: {
              color: "var(--text-primary)",
              fontSize: "30px",
              fontWeight: "bold",
              show: true,
            },
          },
        },
      },
      fill: {
        type: "",
        colors: ["var(--foundation-violet)"],
      },
    };

  const series = [data.conversionRate];

  return (
    <div>
      <Chart options={options} series={series} type="radialBar" height={400} />
      <div className="conversion-count">
        <h4>
          Converted Sessions (<span>{data.convertedSessions}</span>) / Total
          Sessions (<span>{data.totalSessions}</span>)
        </h4>
      </div>
    </div>
  );
};

export default ConversionChart;